<mat-drawer-container class="flex-auto h-full bg-card dark:bg-transparent">

    <!-- Drawer -->
    <mat-drawer
            class="w-2/3 sm:w-60 border-r-0 bg-default"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            #drawer>
        <div class="p-6 lg:py-8 lg:pl-4 lg:pr-0">
            <div class="space-y-2">
                <ng-container *ngIf="batchList">
                    <ng-container *ngFor="let batch of batchList">
                        <div
                                class="relative flex items-center py-2 px-4 font-medium rounded-full cursor-pointer"
                                [ngClass]="{'bg-gray-200 dark:bg-gray-700 text-primary dark:text-primary-400': selectedBatchId === batch.id,
                                'text-hint hover:bg-hover': selectedBatchId !== batch.id}"
                                matRipple
                                [matRippleDisabled]="selectedBatchId === batch.id"
                                (click)="filterByBatch(batch.id)">
                            <mat-icon
                                    class="text-current"
                                    [svgIcon]="batch.icon"></mat-icon>
                            <div class="ml-3 leading-5 select-none text-default">{{batch.displayName}}</div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </mat-drawer>

    <mat-drawer-content class="flex flex-col bg-gray-100 dark:bg-transparent">

        <!-- Main -->
        <div class="flex flex-col flex-auto p-4 md:p-6">

            <!-- Header -->
            <div class="flex flex-col md:flex-row md:items-center">
                <div class="flex items-center flex-auto mb-4 md:mb-0">
                    <button
                            class="flex sm:hidden -ml-2"
                            mat-icon-button
                            (click)="drawer.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                    </button>
                </div>
                <app-ssdf-call-filters-dashboard
                        class="flex flex-col md:flex-row md:items-center md:justify-between md:mb-4 w-full"
                        [filterDates]="filterDates"
                        [selectedDashboardView]="selectedDashboardView"
                        [selectedDateFilter]="selectedDateFilter"
                        [showDashboardViewMenu]="false"
                        (onChangeDateFilterState)="changeDateFilterState($event)"
                        (onChangeDashboardView)="changeDashboardView($event)"
                ></app-ssdf-call-filters-dashboard>
            </div>


            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-6 w-full min-w-0">


                <app-app-for-day-chart
                        class="grid grid-cols-1 w-full col-span-2 md:col-span-6 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden"
                        [generalData]="generalData"
                        [appForDay]="appForDay"></app-app-for-day-chart>

                <div class="grid grid-cols-1 md:grid-cols-3 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
                    <!-- New vs. Returning -->

                    <app-app-formed-company-pie-chart
                            class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                            [formedCompanyData]="formedCompanyData"
                    ></app-app-formed-company-pie-chart>

                    <!-- Gender -->


                    <app-app-patents-pie-chart
                            class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                            [patentsData]="patentsData"
                    ></app-app-patents-pie-chart>


                    <app-app-lab-needed-pie-chart
                            class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                            [labNeededData]="labNeededData"
                    ></app-app-lab-needed-pie-chart>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">


                    <app-app-funding-need-pie-chart
                            class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                            [fundingNeedPieData]="fundingNeedPieData"
                    ></app-app-funding-need-pie-chart>


                    <app-app-origination-pie-chart
                            class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                            [originationData]="originationData"
                            [applicationList]="applicationList"
                    ></app-app-origination-pie-chart>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">


                    <app-app-country-pie-chart
                            class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                            [countryData]="countryData"
                    ></app-app-country-pie-chart>

                    <app-app-area-pie-chart
                            class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                            [zoneData]="zoneData"
                    ></app-app-area-pie-chart>

                </div>


                <app-app-trl-bar-chart
                        class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
                        [appForTrl]="appForTrl"
                >
                </app-app-trl-bar-chart>


                <app-app-for-region-bar-chart
                        class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
                        [appForRegion]="appForRegion"
                ></app-app-for-region-bar-chart>


                <app-val-premoney-day-area-chart
                        class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-0"
                        [appForPremoney]="appForPremoney"
                >
                </app-val-premoney-day-area-chart>

            </div>


        </div>
    </mat-drawer-content>

</mat-drawer-container>
